import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Support from './pages/support';
import DeleteAccount from './pages/deleteAccount';
// import LianWanPrivacyPolicy from './pages/lianwanPrivacy';
import Home from './pages/valid/home';
import AboutUs from './pages/valid/about';
import SupportService from './pages/valid/support';
import OurApp from './pages/valid/ourapp';
import PrivacyPolicy from './pages/valid/privacy';
import PrivacyPolicyLianWan from './pages/valid/app/lianwan/privacy';
import PrivacyPolicyEyesDwell from './pages/valid/app/eyesdwell/privacy';

/**
 * @author Nelson
 */
const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route
          path={'/'}
          element={<Home />} />
        <Route
          path={'/aboutus'}
          element={<AboutUs />} />
        <Route
          path={'/support/service'}
          element={<SupportService />} />
        <Route
          path={'/our/apps'}
          element={<OurApp />} />
        <Route
          path={'/privacy'}
          element={<PrivacyPolicy />} />
        <Route
          path={'/delete'}
          element={<DeleteAccount />} />
        <Route
          path={'/*'}
          element={<Support />} />
        <Route
          path={'/lianwan/privacy'}
          element={<PrivacyPolicyLianWan />} />
        <Route
          path={'/lianwan/privacy/:lang'}
          element={<PrivacyPolicyLianWan />} />
        <Route
          path={'/eyesdwell/privacy'}
          element={<PrivacyPolicyEyesDwell />} />
        <Route
          path={'/eyesdwell/privacy/:lang'}
          element={<PrivacyPolicyEyesDwell />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;